module.exports = __webpack_public_path__ + "img/gotop.6375b66c.png";